define('meeting-modal/tab-options/startup-tab',['require','api-access','api-access','knockout','web-urls'],function (require) {
    var meetingsApi = require('api-access').meetings;
    var userApi = require('api-access').user;
    var ko = require('knockout');
    var openMeetingsEnabledForNamedMeetings = require('web-urls').get('openMeetingsEnabledForNamedMeetings', 'features');
    /**
     * If a meetingId is supplied, the module will assume edit behavior.
     * For schedule behavior, do not supply a meetingId.
     */
    var StartupTab = function (meetingId) {
        var self = this;

        self.passwordRequired = ko.observable(false);
        self.openMeeting = ko.observable(false);
        self.isOpenMeetingFeatureEnabled = ko.observable(false);
        self.isOpenPresenterModeSelected = ko.observable(false);
        self.openMeetingsDisabledForNamedMeetings = !openMeetingsEnabledForNamedMeetings;

        /**
         * Returns relevant data, formatted for consumption by the API.
         */
        self.buildOptions = function () {
            return {
                passwordRequired: self.passwordRequired(),
                startWithoutOrganizerSupported: self.openMeeting()
            };
        };

        self.activate = function () {
            userApi.settings().then(function (settings) {
                self.isOpenMeetingFeatureEnabled(settings.isOpenMeetingsProvisioned && settings.isOpenMeetingsEntitled);
                self.isOpenPresenterModeSelected(settings.presenterMode && (settings.presenterMode === 'open'));

                if (meetingId) {
                    meetingsApi.byIdFormatted(meetingId)
                        .then(function (meeting) {
                            self.passwordRequired(meeting.passwordRequired);
                            if (self.isOpenMeetingFeatureEnabled()) {
                                if (meeting.startWithoutOrganizerSupported !== undefined) {
                                    self.openMeeting(meeting.startWithoutOrganizerSupported);
                                }
                            }
                            self.centerModal();
                        });
                } else {
                    self.openMeeting(settings.isOpenMeetingsDefault);
                }
                self.registerSubscribers();
            });
        };

        self.registerSubscribers = function () {
            if (self.isMutuallyExclusiveFeaturesEnabled()) {
                self.passwordRequired.subscribe(self.onPasswordRequiredChange);
                self.openMeeting.subscribe(self.onOpenMeetingChange);
            }
        };

        self.isMutuallyExclusiveFeaturesEnabled = function () {
            return self.isOpenMeetingFeatureEnabled();
        };

        self.onOpenMeetingChange = function (value) {
            if (value === true) {
                self.passwordRequired(false);
            }
        };

        self.onPasswordRequiredChange = function (value) {
            if (value === true) {
                self.openMeeting(false);
            }
        };

        self.centerModal = function () {
            $(window).trigger('resize');
        };
    };

    return StartupTab;
});

